import { writable } from 'svelte/store';
import type { Plan, PlanStoreType } from '../../types/store';

export const PlanStore = writable<PlanStoreType | null>(null);
export const ShopifyProductStore = writable({});